import { SyntheticEvent } from 'react';

import { useOperationOrders } from 'api/requests/operation';
import { PrimaryClientType } from 'api/types/entity';
import { useSearchDebounce } from 'hooks/useSearchDebounce';
import { useTranslation } from 'libs/i18n';
import { Field } from 'modules/operation/common/forms/operationForm';

interface OrderAutocompleteFeatureProps {
  clientType: PrimaryClientType;
  clientId: string;
  disabled?: boolean;
}

export const OrderAutocompleteFeature = ({
  clientType,
  clientId,
  disabled,
}: OrderAutocompleteFeatureProps) => {
  const { t } = useTranslation();

  const { search, debouncedFunc } = useSearchDebounce();

  const { listData, loading } = useOperationOrders({
    pagination: { limit: 20, page: 0 },
    filter: {
      search,
    },
    params: { clientType, clientId },
  });

  const onChange = () => {
    debouncedFunc('');
  };

  const onInputChange = (_: SyntheticEvent, v: string) => {
    debouncedFunc(v);
  };

  return (
    <Field.Autocomplete
      key={clientId ?? 'order-field'}
      disabledFilterOptions
      fullWidth
      showRequiredMark
      disabled={disabled}
      label={t('operation.sections.clientsOrderSection.fields.order.label')}
      loading={loading}
      name="order"
      optionLabelKey="label"
      options={(listData?.list ?? []).map((order) => ({
        label: order.number,
        value: order.id,
        record: order,
      }))}
      optionValueKey="value"
      placeholder={t(
        'operation.sections.clientsOrderSection.fields.order.placeholder'
      )}
      onChange={onChange}
      onInputChange={onInputChange}
    />
  );
};
